

import React, { useState,useCallback } from 'react';
import styled from 'styled-components';
import { useSwipeable } from 'react-swipeable';
import { loader, visibleTooltip, openDltModal,setDeleteFade } from "../Services/Redux/Reducers/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from '../Components/ArchiveCarousel/DeleteModal';
import { deleteChatData } from "../Services/ApiServices/chatServices";
import { apiError, conversationList, userCheck, isStream, historyListArray } from "../Services/Redux/Reducers/chatSlice";
import { Cookies } from 'react-cookie-consent';
import { useNavigate } from "react-router-dom";
import { cloneDeep } from "lodash";
import { HistoryListProps, SwipeableItemProps } from '../Services/CommonServices/propTypes';
 
const HistoryList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = Cookies?.get('ar_user_Id') ? Cookies.get('ar_user_Id') : "";
  const data = useSelector((state) => state.chat.historyListArray);
  const [activeSwipeIndex, setActiveSwipeIndex] = useState(null);

  const deleteItem = (id) => {
    data?.data?.filter(item => item.id !== id);
  };

  const newChat = () => {
    dispatch(isStream(false))
    dispatch(conversationList([]))
    dispatch(loader(false));
    navigate('/chat');
  }

  const deleteAllHistory = () => {
    if (data?.data?.length === 0) return;
    const params = {
      customerId: userId,
      sesssionId: "",
      deleteAll: true
    }
    deleteChatData(params, (response) => {
      if (response.status === 200) {
        dispatch(userCheck(true));
        let convoList = cloneDeep(data);
        convoList["data"] = [];
        dispatch(historyListArray(convoList))
      }
    }, (err) => {
      dispatch(apiError(err.message));
      dispatch(loader(false));
    });
  }

  return (
    <div id="historyCanvas">
      <Header>
        <div className="btnparent d-flex justify-content-between w-100">
          <div className="d-flex align-items-center btnparent">
            <button name="newChatButton" className="btn" onClick={newChat}>
              <img
                src="./static/assets/chatNew.svg" height="15px" width="14px" alt="img" />
              <span className="btn-label">New Chat</span>
            </button>
          </div>

          <div className="d-flex align-items-center btnparent d-none">
            <button name="deleteAllButton" className="btn" onClick={deleteAllHistory}>
              <img src="./static/assets/dltAllIcon.svg" height="15px" width="14px" alt="img" />
              <span className="btn-label">Delete All</span>
            </button>
          </div>
        </div>
      </Header>
      {data?.data?.length === 0 ? (
        <EmptyState></EmptyState>
      ) : (
        data?.data?.map((item, index) => (
          <SwipeableItem
            key={item.sessionId}
            item={item}
            onDelete={deleteItem}
            isSticky={false}
            isNonSwipable={false}
            index={index}
            activeSwipeIndex={activeSwipeIndex}
            setActiveSwipeIndex={setActiveSwipeIndex}
          />
        ))
      )}
    </div>
  );
};

const SwipeableItem = ({ item, onDelete, isSticky, isNonSwipable, index, activeSwipeIndex, setActiveSwipeIndex }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [swiped, setSwiped] = useState(false);
  const [translateX, setTranslateX] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [height, setHeight] = useState('auto');
  const userId = Cookies?.get('ar_user_Id') ? Cookies.get('ar_user_Id') : "";
  const data = useSelector((state) => state.chat.historyListArray)
  const navigate = useNavigate();
  const [isNewOpen, setNewOpen] = useState(false);
  const [deleteModalFade, setDeleteModalFade] = useState(false);

  const newChat = () => {
    dispatch(isStream(false))
    dispatch(conversationList([]))
    dispatch(loader(false));
    navigate('/chat');
  }

  const handleClose = useCallback(() => {
    setDeleteModalFade(false);
    setShowDelete(false);
    setTranslateX(0);
    setActiveSwipeIndex(null);
    setTimeout(() => {
      setShowModal(false);
      dispatch(openDltModal(false));
    }, 500);
  }, [dispatch, setActiveSwipeIndex]);

  const handlers = useSwipeable({
    onSwiping: (eventData) => {
      if (!isNonSwipable && eventData.dir === 'Left') {
        if (activeSwipeIndex !== null && activeSwipeIndex !== index) {
          return; // Prevent opening if another swipe is active
        }
        setTranslateX(-25);
        setShowDelete(true);
        setActiveSwipeIndex(index);
      }
    },
    onSwipedRight: () => {
      setTranslateX(0);
      setShowDelete(false);
      setActiveSwipeIndex(null);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const handleDelete = () => {
    dispatch(setDeleteFade(true));
    setDeleteModalFade(true);
    setShowModal(true);
  };

  const storeMessage = (sessionId) => {
    const params = {
      customerId: userId,
      sessionId,
      deleteAll: false
    }
    deleteChatData(params, (response) => {
      if (response.status === 200) {
        const deletedItems = data?.data?.filter(item => item.sessionId !== sessionId);
        let convoList = cloneDeep(data);
        convoList["data"] = deletedItems;
        dispatch(historyListArray(convoList))
        dispatch(userCheck(true))
      }
    }, (err) => {
      dispatch(apiError(err.message));
      dispatch(loader(false));
    });
  }

  const confirmDelete = () => {
    storeMessage(item.sessionId);
    setSwiped(true);
    setDeleteModalFade(false);
    setShowDelete(false);
    setTranslateX(0);
    setActiveSwipeIndex(null);
    setTimeout(() => {
      setShowModal(false);
      dispatch(openDltModal(false));
      setHeight('0');
      setTimeout(() => onDelete(item.sessionId), 300);
    }, 500);
  };

  // Close swipe when another one opens
  React.useEffect(() => {
    if (activeSwipeIndex !== null && activeSwipeIndex !== index && showDelete) {
      setShowDelete(false);
      setTranslateX(0);
    }
  }, [activeSwipeIndex, index, showDelete]);

  const handleClick = (props) => {
    const { userId, sessionId } = props;
    navigate("/chathistory", { state: { userId, sessionId } });
  }

  const handleTransitionEnd = () => {
    if (swiped) {
      onDelete(item.sessionId);
    }
  };

  const dateChanger = (dateString) => {
    const dateObj = new Date(dateString);
    const formattedDate = dateObj.toLocaleDateString('en-US', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });
    return formattedDate
  }

  const timeChanger = (time) => {
    const now = new Date(time);
    const formattedTime = now.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    return formattedTime;
  }

  const openTooltip = (i) => {
    dispatch(visibleTooltip(i));
    setNewOpen(true);
  }

  const tooltipClose = () => {
    setTimeout(() => {
      setNewOpen(false);
    }, 500);
  }

  const deleteModalOpen = () => {
    dispatch(setDeleteFade(true));
    setDeleteModalFade(true);
    setShowModal(true);
    setNewOpen(false);
  };

  return (
    <>
      <ItemContainer
        height={height}
        $isSticky={isSticky}
        $swiped={swiped}
        $translateX={translateX}
        onTransitionEnd={handleTransitionEnd}
        className="px-0"
        {...handlers}
      >
        <div className="content-container border-0 bg-transparent" style={{ position: "relative", width: translateX ? "90%" : "100%" }}>
          <div className="chat-copy" onClick={() => handleClick(item)}>
            <img className="iconStyle" src={"./static/assets/RLChat_black.svg"} alt="chat-icon" />
            <span className="ms-2 textTruncate qStyle">
              {item?.question}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center date-div">
            <span className="dayDateStyle">
              {timeChanger(item.requestDateTime)}&nbsp;:&nbsp;{dateChanger(item.requestDateTime)}
            </span>
            <button 
              name="menuButton"
              className="p-0 border-0 bg-transparent d-flex align-items-center"
              onClick={() => { openTooltip(index); }}
            >
              <img
                src={"./static/assets/threeDotgrp.svg"}
                width="20px"
                height="20px"
                alt="chat-icon"
                className="three-dots"
              />
            </button>
          </div>
        </div>

        {showDelete &&
          <DeleteButton $swiped={swiped} onClick={handleDelete}>
            <img style={{width: "31px", height: "36px"}} src={"./static/assets/dltCard.svg"} width="100%" alt="dlt-icon" />
          </DeleteButton>
        }
      </ItemContainer>

      {showModal &&
        <DeleteModal
          visibleModal={showModal}
          handleClose={handleClose}
          confirmDelete={confirmDelete}
          handleDelete={handleDelete}
          fadeClass={deleteModalFade ? 'tooltip-fadein' : 'tooltip-fadeout'}
        />

      }

      {isNewOpen && (
        <div className="modal d-flex archive-container archive-modal" id="" role="dialog" style={{ display: "block" }}>
          <div className="modal-content">  
            <button
              name="closeButton"
              type="button"
              className="close_btn tooltip_close align-self-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={tooltipClose}
            >
              <img
                height="16px"
                width="16px"
                src="./static/assets/Close_icon.svg"
              />
            </button>
            <div className="modal-content_inner pt-2">
              <div className="modal-body">
                <div className="custom-xs-tooltip d-sm-none">
                  <div className="d-flex justify-content-center align-items-start flex-column text-left">
                    <div className="d-flex align-items-center mrgn-btm">
                      <button name="newChatButton" className="btn p-0" onClick={newChat}>
                        <img
                          src="./static/assets/chatNew.svg" height="15px" width="15px" alt="img" />
                        <span className="btn-label-chat">New Chat</span>
                      </button>
                    </div>

                    <div className="d-flex align-items-center" >
                      <button name="deleteChatButton" className="btn p-0" onClick={deleteModalOpen}>
                        <img src="./static/assets/qtyStepperDelete.svg" height="15px" width="15px" alt="img" />
                        <span className="btn-label-dlt">Delete</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 16px;
  background-color: white;
  border-bottom: 1px solid #ccc;
  position: sticky;
  top: 0;
  z-index: 1;  
  height:57px;
`;

const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  background-color: ${({ $isSticky }) => ($isSticky ? 'lightgray' : 'white')};
  position: ${({ $isSticky }) => ($isSticky ? 'sticky' : 'static')};
  top: ${({ $isSticky }) => ($isSticky ? '0' : 'auto')};
  z-index: ${({ $isSticky }) => ($isSticky ? '1' : 'auto')};
  margin: 0;
  transform: ${({ $swiped, $translateX }) => ($swiped ? 'translateX(-200%)' : `translateX(${$translateX}px)`)};
  transition: transform 0.3s ease-in-out;
  height: ${({ height }) => height};
`;

const DeleteButton = styled.button`
  // background-color:  #FOEEEDtransparent;
  color:  #FOEEED;
  border: none;
  padding: 33.5px 15px 32.5px 14px;
  cursor: pointer;
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  height:${({ $swiped }) => ($swiped ? '0' : '100%')};
  width: 60px;
  height: 102px;
`;

const EmptyState = styled.div`
  padding: 20px;
  text-align: center;
  color: gray;
`;

HistoryList.propTypes = HistoryListProps;

SwipeableItem.propTypes = SwipeableItemProps;

export default HistoryList;